/* Auto Generated */

export enum TrainingCalculationErrorCode {
	none = 0,
	unknown = 1,
	internalServerError = 2,
	durationError = 3,
}
